
<template>
    <BForm class="row">
        <BFormGroup class="col-12 pb-4" id="name-input-group" label="Назва">
            <BFormInput
                v-model="tender.name"
                :state="isValidname"
            ></BFormInput>
        </BFormGroup>
        
        <BFormGroup class="col-md-6 pb-4" id="group-input-group" label="Група категорії закупки">
            <v-select
                :options="groups"
                v-model="tender.cat_group_id"
                :reduce="group => group.id"
                label="ua_name"
                @update:modelValue="updateCategories"
            ></v-select>
        </BFormGroup>
        
        <BFormGroup class="col-md-6 pb-4" id="categories-input-group" label="Категорії закупки">
            <v-select
                :class="styleChooser"
                label="ua_name"
                :options="categories"
                v-model="tender.categories"
                :reduce="categories => categories.id"
                @update:modelValue="getSubscribes"
                :state="isValidcategories"
                multiple
            ></v-select>
            <template #no-options>
                Спочатку виберіть групу
            </template>
        </BFormGroup>
        
        
        <BFormGroup class="col-md-6 pb-4" id="mem-input-group" label="Номер службової на проведення тендера">
            <v-select multiple
                      v-model="activeReasons"
                      @search="onSearch"
                      @change="push_reason_str"
                      class="imc_reasons"
                      label="number"
                      :filterable="false"
                      :options=multi_reasons>
                <template #no-options>
                    Починайте вводити номер службової
                </template>
                
                <template #option="{ number, title }">
                    <div class="d-center">
                        {{ number }}
                        <div>
                            <small>{{ title }}</small>
                        </div>
                    </div>
                </template>
            </v-select>
        </BFormGroup>
        
        <BFormGroup class="col-md-6" label="Період проведення тендера">
            <date-picker
                v-model:value="time_range"
                :lang="d_lang"
                type="datetime"
                range
                confirm
                format="YYYY-MM-DD HH:mm:00"
                :first-day-of-week="1"
                value-type="format"
                :minute-step="10"
                :showSecond="false"
                @change="setDate"
            ></date-picker>
        </BFormGroup>
        
        <BFormGroup class="col-md-6" id="deliverys-input-group" label="Умови постачання">
            <v-select
                label="title"
                :options="deliveries"
                :reduce="delivery => delivery.id"
                v-model="tender.delivery_id"
            
            ></v-select>
        </BFormGroup>
        
        <BFormGroup class="col-md-6" label="Очікувана дата постачання">
            <date-picker
                v-model:value="tender.date_delivery"
                :lang="d_lang"
                type="date"
                value-type="format"
                format="YYYY-MM-DD"
                :first-day-of-week="1"
            ></date-picker>
        </BFormGroup>
        
  
        <BFormGroup v-if="is_reduction" class="col-md-4  mt-4" label="Продовжувати редукціон протягом хвилин">
            <BFormInput type="number" v-model="tender.time_long"></BFormInput>
        </BFormGroup>
        
        <BFormGroup v-if="is_reduction" class="col-md-4  mt-4" label="При ставці продовжити на хвилин">
            <BFormInput type="number" v-model="tender.time_short"></BFormInput>
        </BFormGroup>
        
        <BFormGroup v-if="is_reduction" class="col-md-4  mt-4" label="Валюта тендера">
            <v-select
                label="name"
                :options="currencies"
                :reduce="currency => currency.id"
                v-model="tender.currency_id"
            ></v-select>
        </BFormGroup>
      
        
        
        <payment :payment="tender.payment"></payment>
    </BForm>
</template>

<script>
import DatePicker from 'vue-datepicker-next';
import vSelect from 'vue-select';
import {BForm, BFormGroup, BFormInput,} from 'bootstrap-vue-next';

import payment from "./fields/payment.vue";


export default {
    name: "tender_general",
    
    props : {
        tender : {
            type : Object
        }
    },
    
    emits : ['changeAtr'],
    
    components : {
        payment,
     
        vSelect,
        DatePicker,
        BForm,
        BFormGroup,
        BFormInput
    },
    
    data() {
        return {
            is_load : false,
            groups : [],
            deliveries : [],
            currencies : [],
            multi_reasons : [],
            activeReasons : [],
            time_range: [],
        }
    },
    
    created() {
        this.loadGroups();
        this.loadDeliveries();
        this.loadCurrencies();
        
        this.init_exist_tender();
        EventBus.$on('reload_tender',this.init_exist_tender);
     
    },
    
    methods : {
        
        init_exist_tender() {
    
            
            if(parseInt(this.tender.id) > 0) {
                if (this.tender.hasOwnProperty('activeReasons')) {
                    this.activeReasons = this.tender.activeReasons;
                }
                
                if (this.tender.hasOwnProperty('date_from')) {
                    this.time_range[0] = this.tender.date_from;
                    this.time_range[1] = this.tender.date_to;
                }
                
                /*if (this.tender.hasOwnProperty('payment')) {
                    let payment_id = this.tender.payment_id;
                    if (parseInt(payment_id) > 0) {
                        console.log('payment_set_before',this.tender);
                        this.tender.payment = this.tender.payment.params;
                        console.log('payment_set_after',this.tender);
                    }
                }*/
                
                if (this.tender.hasOwnProperty('categories')) {
                    this.getSubscribes();
                }
            }
            
        },
        
        async loadCurrencies() {
            this.currencies = [];
            
            await api.get('/tenders/sales/tenders/helpers/currencies').then(({data}) => {
                if(data.status === "operation_success") {
                    this.currencies = data.data;
                }
            });
        },
        
        async loadDeliveries() {
            this.deliveries = [];
            await api.get('/tenders/sales/tenders/helpers/deliveries').then(({data}) => {
                if(data.status === "operation_success") {
                    this.deliveries = data.data;
                }
            })
        },
      
        async loadGroups() {
            this.groups = [];
            const { data } = await api.get('/tenders/general/subscribes');
            if (data.status === "operation_success") {
                this.groups = data.data;
            }
        },
        
        
        
        async getSubscribes() {
            console.log('loadSubscribes');
            this.tender.subscribes = [];
            
            const { data } = await api.post('/tenders/sales/tenders/' + parseInt(this.tender.id) + "/subscribes",{
                'categories' : this.tender.categories
            });
            if (data.status === "operation_success") {
                this.tender.subscribes = data.data;
            }
        },
        
        updateCategories() {
            this.tender.categories = [];
            this.getSubscribes();
        },
        
        onSearch(search, loading) {
            if(search.length > 2) {
                loading(true);
                this.search(loading, search);
            }
        },
        
        push_reason_str (cur_val) {
            let str = "";
            let nmb_str = [];
            
            this.activeReasons.map(item => {
                nmb_str.push(item.number);
            });
            this.tender.memoramdum_number = nmb_str.join(";");
        },
        
        async search(loading, search)  {
            await api.get('/memorandum/items/search/' + search).then(({data}) => {
                loading(false);
                this.multi_reasons =[];
                if(data.status == "operation_success") {
                    this.multi_reasons = data.data;
                }
                
            }).catch(err => {
                this.multi_reasons =[];
                loading(false);
            });
        },
        
        setDate(val) {
            this.time_range = val;
            this.changeValue('date_from', val?.[0] || null);
            this.changeValue('date_to',   val?.[1] || null);
        },
        
        
        changeValue(type,val) {
            this.tender[type] = val;
            this.$emit('changeAtr',type,val);
        },
        
    },
    
    computed : {
        
        tenderPaymnet() {
        
        },
        
        isValidname() {
            return this.tender.name.length > 2;
        },
        
        isValidcategories () {
            return this.categories.length > 0 ;
        },
        
        activeGroup() {
            let active_group = null;
            if(this.tender.cat_group_id > 0) {
                this.groups.map(item => {
                    if(parseInt(item.id) == parseInt(this.tender.cat_group_id)) {
                        active_group = item;
                    }
                })
            }
            
            return active_group;
        },
        
        categories() {
            if(this?.activeGroup) {
                if(this.activeGroup.hasOwnProperty("cats")) {
                    return this.activeGroup.cats;
                }
            }
            
            
            return [];
        },
        
        
        styleChooser () {
            let res = ''
            if (!this.isValidcategories) {
                res = 'is-invalid'
            }
            return res
        },
        
        d_lang() {
            return window.dLang.lang;
        },
        
        is_reduction() {
            return this.tender.tender_type == 'second_reduction';
        }
    }
    
}
</script>


<style scoped>

</style>